import { render, staticRenderFns } from "./createEdit.vue?vue&type=template&id=6dcdcc6b&scoped=true&"
import script from "./createEdit.vue?vue&type=script&lang=js&"
export * from "./createEdit.vue?vue&type=script&lang=js&"
import style0 from "./createEdit.vue?vue&type=style&index=0&id=6dcdcc6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcdcc6b",
  null
  
)

export default component.exports